
function SuspenseLoader() {
    return (
    <div>
      Loading...
    </div>
    );
  }
  
  export default SuspenseLoader;
  